<template>
  <div class="addCostFee">
    <md-popup v-model="show" :mask-closable="false">
      <md-popup-title-bar title="新增成本费用" :only-close="true" @cancel="cancelPop()"></md-popup-title-bar>
      <div class="pop_content">
          <md-field>
            <md-field-item solid title="费用类型">
              <md-radio-group v-model="subData.type">
                <md-radio-box v-for="(item,index) in pack_list" :key="index" :name="item.value" >{{item.name}}</md-radio-box>
              </md-radio-group>
            </md-field-item>
            <md-input-item title="费用名称" clearable type="text" v-model="subData.name" placeholder="请输入费用名称"></md-input-item>
          </md-field>
          <div class="pop_btns">
            <md-button type="warning" plain size="small" inline @click="cancelPop()">取消</md-button>
            <md-button type="primary" size="small" inline @click="submitData()">保存</md-button>
          </div>
      </div>
    </md-popup>

  </div>
</template>

<script>
import { costFee_update } from "@/api/work/stock";
import { isEmpty, isMobile  } from "@/utils/validate";
export default {
  name: 'addCostFee',
  data(){
    return {
      show:false,
      loading:true,
      pack_list: [
        { value: '1', name: "产地费用" ,desc:'货主承担的费用，将计入未付货款中'},
        { value: '2', name: "市场费用" ,desc:'销售过程中发生的费用，如场租，工资等'}
      ],
      subData:{
        id:'',
        name:'',
        type:'1',
        status:'1',
        sort:'0'
      },
    }
  },
  created(){
    
  },
  mounted(){

  },
  methods:{
    // 显示弹窗
    showPop(item){
      if(item){
        this.subData = {
          id:item.id,
          name:item.name,
          type:item.type + '',
          status:'1',
          sort:'0'
        }
      }
      this.show = true
    },
    // 取消弹窗
    cancelPop(){
      this.show = false
      this.resetData()
      this.$emit("cancel")
    },
    // 取消弹窗
    finishPop(){
      this.show = false
      this.resetData()
      this.$emit("finish")
    },
    // 重置数据
    resetData(){
      this.subData = {
        id:'',
        name:'',
        type:'1',
        status:'1',
        sort:'0'
      }
    },
    // 提交数据
    submitData(type){
      if(!this.subData.name){this.$toast.info("请输入费用名称！"); return false }
      if(!this.loading){ return false }
      this.loading = false
      costFee_update(this.subData).then(res=>{
        this.loading = true
        this.$toast.succeed(res.message)
        this.finishPop()
      }).catch(err=>{
        this.loading = true
      })
    },
  }
}
</script>

<style lang="less" scoped>
.addCostFee{
  position: relative;
  // 添加买家模块
  .pop_content {
    width: 5rem;
    // height: 6rem;
    background-color: #fff;
    border-radius:0 0 0.08rem 0.08rem;
    overflow: hidden;
    padding:0.1rem 0.2rem 0;
    position: relative;
    .pop_btns{
      padding: 0.35rem 1rem 0.2rem;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
  }
}
</style>